export const dateFormat = (date: string, withHour = false): string => {
  if (!date) {
    return '';
  }
  if (withHour) {
    const dateHourPart = date.split('T');
    const datePart = dateHourPart[0].split('-');
    const hourPart = dateHourPart[1].split('.');
    return `${datePart[2]}/${datePart[1]}/${datePart[0]} ${hourPart[0]}`;
  }
  const datePart = date.split('-');
  return `${datePart[2]}/${datePart[1]}/${datePart[0]}`;
}


export const extractDateFormat = (date: string): string => {
  const dateHourPart = date.split('T');
  const datePart = dateHourPart[0].split('-');
  return `${datePart[2]}/${datePart[1]}/${datePart[0]}`;

}
export const extractHourFormat = (date: string): string => {

  const dateHourPart = date.split('T');
  const hourPart = dateHourPart[1].split('.');
  return `${hourPart[0]}`;


}

export const extractDateFormatAlternative = (date: string): string => {
  const datePart = date.split('/');
  return `${new Date(datePart[2] + '/' + datePart[1] + '/' + datePart[0])}`;
}

export function dateformat(date: string, hours = false): string {
  if (!date) {
    return '';
  }

  if (hours) {
    const [datePart, hourPart] = date.includes('T') ? date.split('T') : date.split(' ');
    const [year, month, day] = datePart.split('-');
    const time = hourPart.slice(0, 5);
    return `${day}/${month}/${year} ${time}`;
  }

  const datePart = date.split('-');
  const [year, month, day] = datePart;
  return `${day}/${month}/${year}`;
}

export function timeformat(time: string): string {
  if (!time) {
    return '';
  }

  return time.slice(0, 5);
}

export default dateFormat;